export default () => `
  mutation sendCurrentOrder($email: String!, $newsletterSubscribed: Boolean!){
    sendCurrentOrder(
      email: $email,
      newsletterSubscribed: $newsletterSubscribed
    ) {
      success
      message
    }
  }
`
